export default __webpack_public_path__ + "static/ssb_logo_new-0caa3fd6f7a8444ea54fcb1a541f41ed.png";